import { FC } from 'react';
import { NudosButton, NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import { IlogisticServiceTrelloCardData } from '../../../../../types/services';
import LogisticsServiceTrelloCard from '../../LogisticsServiceTrelloCard/LogisticsServiceTrelloCard';
import { getNudosData } from '../../../../../utils/getNudosData';
import { TchangeLogisticServiceStatusCallback } from '../LogisticsServicesTrelloModals';
import './CancelModalLS.scss';

interface ICancelModalLS {
  closeModal?: () => void;
  updateDataCallBack: TchangeLogisticServiceStatusCallback;
  onlyItemCard: IlogisticServiceTrelloCardData;
  closeAndRestoreList?: () => void;
  loading?: boolean;
}

const CancelModalLS: FC<ICancelModalLS> = ({
  closeModal,
  onlyItemCard,
  updateDataCallBack,
  closeAndRestoreList,
  loading
}: ICancelModalLS) => {
  const nudosData = getNudosData();
  const cancelLS = async () => {
    const body = {
      status: 'cancelado',
      userId: Number(nudosData?.userData?.id)
    };
    updateDataCallBack(body, closeModal);
  };

  return (
    <>
      <NudosGenericModal
        closeModalCallback={() => {
          if (closeAndRestoreList) {
            closeAndRestoreList();
          }
        }}
        clickOutsideCallback={() => {
          if (closeAndRestoreList) {
            closeAndRestoreList();
          }
        }}
        modalContent={
          <NudosModalContent
            noScroll
            customWidth="580px"
            customHeight="426px"
            modalContentTitle="Cancelar servicio"
            toCloseModal={() => {
              if (closeAndRestoreList) {
                closeAndRestoreList();
              }
            }}
            CustomModalComponent={
              <div id="cancelModalLS">
                <div className="containerCancelModal">
                  <div className="titleCancel">Estás a punto de cancelar el siguiente servicio:</div>
                  <div className="centerCardCancel">
                    <div className="containerCard">
                      <LogisticsServiceTrelloCard
                        cardStatusColumnClassname="noMargin"
                        logisticServiceData={onlyItemCard}
                      />
                    </div>
                  </div>
                  <div className="questionText">¿Seguro que deseas continuar? </div>
                  <div className="containerButtons">
                    <NudosButton
                      handleClick={() => {
                        if (closeAndRestoreList) {
                          closeAndRestoreList();
                        }
                      }}
                      colorPalette="secondary"
                      customClassName="firstButton"
                      buttonText="Mantener"
                      isButtonDisabled={loading}
                    />
                    <NudosButton
                      isButtonDisabled={loading}
                      isButtonLoading={loading}
                      handleClick={() => {
                        cancelLS();
                      }}
                      customClassName="secondButton"
                      buttonText="Cancelar Servicio"
                    />
                  </div>
                </div>
              </div>
            }
          />
        }
      />
    </>
  );
};

export default CancelModalLS;
